/**
 * from https://stackoverflow.com/a/2117523
 * */
export function uuidv4() {
    // @ts-expect-error: look https://stackoverflow.com/a/2117523
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (id) => (id ^ (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (id / 4)))).toString(16));
}
export function deferEvent(event) {
    return debounceEvent(event, 0);
}
export function debounceEvent(event, wait) {
    const original = (event === null || event === void 0 ? void 0 : event['_original']) || event;
    return {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        _original: event,
        emit: debounce(original.emit.bind(original), wait),
    };
}
export function debounce(func, wait = 0) {
    let timer;
    // @ts-expect-error: TS2322
    return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(func, wait, ...args);
    };
}
export const identity = (id) => id;
// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop = () => { };
/**
 * Creates a function that returns the result of invoking the given an array of functions,
 * where each successive invocation is supplied the return value of the previous
 */
export const flow = (fns) => (arg) => fns.reduce((acc, fn) => fn(acc), arg);
/**
 * Creates a function that returns the result of invoking the given functions,
 * where each successive invocation is supplied the return value of the previous
 */
export const pipe = (...fns) => (arg) => fns.reduce((acc, fn) => fn(acc), arg);
/**
 * This function invokes fn with argument val and returns val
 */
export const tap = (fn) => (val) => {
    fn(val);
    return val;
};
export const isNil = (value) => value === null || value === undefined;
export const isObject = (obj) => Boolean(obj) && typeof obj === 'object';
